import { render } from "./AdviseWorkspace.vue?vue&type=template&id=175c7ccb&scoped=true"
import script from "./AdviseWorkspace.vue?vue&type=script&lang=js"
export * from "./AdviseWorkspace.vue?vue&type=script&lang=js"

import "./AdviseWorkspace.vue?vue&type=style&index=0&id=175c7ccb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-175c7ccb"]])

export default __exports__